import { isString } from 'lodash';
import insertStyleSheet from 'insert-stylesheet';
import cssProperties from 'css-custom-properties';

const symbols = {
  dom: Symbol('dom instance property'),
};

const loadStyleSheet = url => new Promise((resolve, reject) => (
  insertStyleSheet(url, (err, node) => {
    if (err) {
      reject(err);
    } else {
      resolve(node);
    }
  })
));

const loadStyleSheets = urls => Promise.all(urls.map(loadStyleSheet));

export default class Styles {
  constructor(domInstance) {
    this[symbols.dom] = domInstance;
  }

  load(url = []) {
    const urls = isString(url) ? [url] : url;

    return loadStyleSheets(urls);
  }

  setVariables(vars) {
    cssProperties.set(vars);
  }
}



// WEBPACK FOOTER //
// ./src/Dom/Styles.js